import { OrderApiException, OrderErrorCode, Promotion, Reward } from '@/models';
import Vue from 'vue';
import { Component, Prop, Watch} from 'vue-property-decorator';
import { AccountManagementEvent } from '@/services/analytics/events';
import { InteractionTrackingType } from '@/services/analytics/platforms/adobe-analytics/models';
@Component({
    name: 'CmgRewardsList',
})
    
  export default class CmgRewardsListModal extends Vue {    
    get rewards() {
      return (this.$appStore.state.ui.modals.rewardsListModal.args?.rewards || this.$appStore.state.customer.wallet.promotions);
    }

    get visible(): boolean {
      return !!this.$appStore.state.ui.modals.rewardsListModal.visible;
    }
  
    get isMobile(): boolean {
      return this.$services.ui.isMobile();
    }
  
    get modalWidth(): string {
      return this.bagRewards.length > 1 ? '52em' : '30em';
    }
  
    get bagRewards(): Reward[] {
      return this.$appStore.state.reward.bagRewards;
    }

  async onClickAddReward(reward: Promotion) {
    this.$services.ui.setLastSelectedElement('bag');
    this.$services.ui.setAppPepperVisibility(true);

    this.$services.analytics.send(new AccountManagementEvent(InteractionTrackingType.RewardsAddedToBag, undefined, reward.promotionName, 'Rewards List'));

    let order = this.$services.order.getCurrentOrder();
    const promotionCode = reward.promotionCode;

    if (!order) {
      if (this.$appStore.state.restaurant.selectedRestaurant) {
        order = await this.$services.order.createOrder(this.$appStore.state.restaurant.selectedRestaurant!.restaurantNumber);
      } else {

        this.$services.ui.setModalVisibility('findAChipotle', true, {
          onClose: async () => {
            if (!order || !this.$appStore.state.restaurant.selectedRestaurant) {
              return;
            }

            try {
              order = await this.$services.order.createOrder(this.$appStore.state.restaurant.selectedRestaurant.restaurantNumber,);

              if (order && promotionCode) {
                await this.$services.order.applyDiscountToOrder(order, promotionCode);

                this.$services.bag.setBagVisibility(true);
                this.displayRewardToast(true);
              }
            } catch (e) {
              this.handleAddToBagException(e);
            }
          },
        });

        this.$services.ui.setModalVisibility('toast', true, {
          body: 'Before you order, we gotta find your Chipotle first.'.toUpperCase(),
          bodyOnly: true,
        });
        Vue.nextTick(() => this.$services.ui.focusFirstDiv('.cmg-modal-container'));
        return;
      }
    }

    if (!order) {
      return;
    }
    try {
      this.$services.ui.setModalVisibility('rewardsListModal', false);
      if (!order.discounts || !order.discounts.find(d => d.promotionCode === promotionCode)) {

        await this.$services.order.applyDiscountToOrder(order, promotionCode);

        this.$nextTick(() => {
          Vue.nextTick(() => this.$services.ui.focusDiv('.fullModal'));
          this.$services.ui.setLastSelectedElement('bag');
        });
      } else {
        await this.$services.order.removeDiscountFromOrder(order, promotionCode);

        Vue.nextTick(() => this.$services.ui.focusDiv('.fullModal'));
      }

    } catch (e) {
      this.handleAddToBagException(e);
    } finally {
      this.$services.ui.setAppPepperVisibility(false);
      this.displayRewardToast(true);
      this.$emit('rewardAdded');
    }
  }
  
  get rewardToastVisible() {
    return this.$appStore.state.ui.bag.bagToastVisibility;
  }

  displayRewardToast(visible: boolean) {
    this.$services.ui.setBagRewardsToastVisible(visible);
  }
  
  private handleAddToBagException(e: any) {
    if (!(e instanceof OrderApiException)) {
      throw e;
    }

    const error = e.errors[0];
    if (!error) {
      throw e;
    }

    switch (error.errorCode) {
      case OrderErrorCode.RewardExceedsLimit:
        this.$services.ui.setModalVisibility('toast', true, {
          title: '',
          body: 'Only one reward per order.',
          bodyOnly: true,
        });
        Vue.nextTick(() => {
          setTimeout(() => {
            this.$services.ui.nextFocus('reward-heading');
          }, 6000);
        });
        break;
    }
  }

  onClose() {
    this.$services.ui.setAppPepperVisibility(false);
      this.$services.ui.setModalVisibility('rewardsListModal', false);
    }
  }
